// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDKfLV-jBLYJTGGN8tJuoQ96GetrRV7Z8w",
    authDomain: "cloud-service-tech.firebaseapp.com",
    projectId: "cloud-service-tech",
    storageBucket: "cloud-service-tech.firebasestorage.app",
    messagingSenderId: "198303450360",
    appId: "1:198303450360:web:f3dd70dbbe56f1c9c9270d",
    measurementId: "G-604GXNQHNY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, db, storage };